import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { listCodeForDuesProtect } from '../../../dataMapper/claimCodeMapper';
import { appConfig } from '../../../../../configureApp';
import {
  DeclarationSection,
  StandardConsentSection,
  VisitorsToCanadaSection,
  DuesProtectSection,
} from './components';

function SubmitClaim(props) {
  const {
    submitted,
    signature,
    handleChange,
    emailAddress,
    showElectronicConsentDocument,
    electronicConsentDocument,
    errorEmails,
    TPAName,
    carrier,
    insuredsList,
    isClaimGroupAllowed,
    declarationSignature,
    privacyActAuthorisationSignature,
    isClaimForFieldEnabled,
    showWarningMissingRequiredDocument,
    showWarningInvalidRequiredDocument,
    warningMissingRequiredDocument,
    isVisitorsToCanada,
    intl,
  } = props;

  const { selectedBenefits } = props.stepWhatHappenedData;

  // Computed values
  const isMultipleClaimFor = insuredsList.length > 1 && isClaimGroupAllowed;
  const list = (!!selectedBenefits && typeof selectedBenefits.toJS === 'function')
    ? selectedBenefits.toJS()
    : (selectedBenefits || []);
  const isVisibleDuesProtect = list.filter((d) =>
    listCodeForDuesProtect.filter((c) => c === d.claimCode).length > 0
  ).length > 0;
  const isReadOnly = submitted;

  // Determine which section to render based on conditions
  const isTugoApp = appConfig.reactAppEnv === 'tugo';
  const shouldShowTugoAppSection = isVisitorsToCanada || isTugoApp;
  const shouldShowDeclaration = !shouldShowTugoAppSection && !isVisibleDuesProtect && isClaimForFieldEnabled;
  const shouldShowStandardConsent = !shouldShowTugoAppSection && !isVisibleDuesProtect && !isClaimForFieldEnabled;
  const shouldShowDuesProtect = isVisibleDuesProtect;

  return (
    <div>
      {shouldShowDeclaration && (
        <DeclarationSection
          isReadOnly={isReadOnly}
          declarationSignature={declarationSignature}
          privacyActAuthorisationSignature={privacyActAuthorisationSignature}
          handleChange={handleChange}
          intl={intl}
        />
      )}

      {shouldShowTugoAppSection && (
        <VisitorsToCanadaSection
          TPAName={TPAName}
          carrier={carrier}
          showFraudNotice={appConfig.showFraudNotice}
          showWarningMissingRequiredDocument={showWarningMissingRequiredDocument}
          showWarningInvalidRequiredDocument={showWarningInvalidRequiredDocument}
          warningMissingRequiredDocument={warningMissingRequiredDocument}
          showElectronicConsentDocument={showElectronicConsentDocument}
          electronicConsentDocument={electronicConsentDocument}
          emailAddress={emailAddress}
          errorEmails={errorEmails}
          signature={signature}
          isMultipleClaimFor={isMultipleClaimFor}
          isReadOnly={isReadOnly}
          handleChange={handleChange}
          intl={intl}
        />
      )}

      {shouldShowStandardConsent && (
        <StandardConsentSection
          TPAName={TPAName}
          carrier={carrier}
          showFraudNotice={appConfig.showFraudNotice}
          showWarningMissingRequiredDocument={showWarningMissingRequiredDocument}
          showWarningInvalidRequiredDocument={showWarningInvalidRequiredDocument}
          warningMissingRequiredDocument={warningMissingRequiredDocument}
          showElectronicConsentDocument={showElectronicConsentDocument}
          electronicConsentDocument={electronicConsentDocument}
          emailAddress={emailAddress}
          errorEmails={errorEmails}
          signature={signature}
          isMultipleClaimFor={isMultipleClaimFor}
          isReadOnly={isReadOnly}
          handleChange={handleChange}
          intl={intl}
        />
      )}

      {shouldShowDuesProtect && (
        <DuesProtectSection
          signature={signature}
          isReadOnly={isReadOnly}
          handleChange={handleChange}
          intl={intl}
        />
      )}
    </div>
  );
}

SubmitClaim.propTypes = {
  submitted: PropTypes.bool,
  signature: PropTypes.bool,
  emailAddress: PropTypes.any,
  handleChange: PropTypes.func,
  stepWhatHappenedData: PropTypes.any,
  showWarningMissingRequiredDocument: PropTypes.bool,
  showWarningInvalidRequiredDocument: PropTypes.bool,
  warningMissingRequiredDocument: PropTypes.string,
  showElectronicConsentDocument: PropTypes.bool,
  electronicConsentDocument: PropTypes.bool,
  errorEmails: PropTypes.any,
  TPAName: PropTypes.any,
  carrier: PropTypes.any,
  insuredsList: PropTypes.any,
  declarationSignature: PropTypes.bool,
  privacyActAuthorisationSignature: PropTypes.bool,
  isClaimForFieldEnabled: PropTypes.bool,
  isClaimGroupAllowed: PropTypes.bool,
  isVisitorsToCanada: PropTypes.bool,
  intl: intlShape.isRequired,
};

export default injectIntl(SubmitClaim);



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepDeclaration/components/SubmitClaim/index.js